<template>
  <div class="h-auto">
    <img src="@/assets/images/pages/main/cleanToEarn/tree.png" alt="" class="tree">
    <!-- leaf image @todo : animation 'on' class 추가     -->
    <img src="@/assets/images/pages/main/cleanToEarn/leaf1.png" alt="" class="leaf1 on absolute">
    <img src="@/assets/images/pages/main/cleanToEarn/leaf2.png" alt="" class="leaf2 on absolute">
    <img src="@/assets/images/pages/main/cleanToEarn/leaf3.png" alt="" class="leaf3 on absolute">
    <img src="@/assets/images/pages/main/cleanToEarn/leaf4.png" alt="" class="leaf4 on absolute">
    <img src="@/assets/images/pages/main/cleanToEarn/leaf5.png" alt="" class="leaf5 on absolute">
    <img src="@/assets/images/pages/main/cleanToEarn/leaf1.png" alt="" class="leaf6 on absolute">
  </div>
</template>

<script>
export default {
  name: 'Tree'
}
</script>

<style lang="scss" scoped>
div::v-deep {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;

  .tree {
    width: 100%;
  }

  .leaf1 {
    &.on {
      animation: leaf1 3s 0s linear infinite;
      bottom: 50%;
    }
  }

  .leaf2 {
    &.on {
      animation: leaf2 2s 0s linear infinite;
      bottom: 50%;
    }
  }

  .leaf3 {
    &.on {
      animation: leaf3 3.5s 0s linear infinite;
      bottom: 50%;
    }
  }

  .leaf4 {
    &.on {
      animation: leaf4 2s 0s linear infinite;
      bottom: 50%;
    }
  }

  .leaf5 {
    &.on {
      animation: leaf5 2.5s 0s linear infinite;
      bottom: 50%;
    }
  }

  .leaf6 {
    &.on {
      animation: leaf6 2.3s 0s linear infinite;
      bottom: 50%;
    }
  }

  .leaf7 {
    &.on {
      animation: leaf6 2.3s 0s linear infinite;
      bottom: 50%;
    }
  }

  @keyframes leaf1 {
    0% {
      transform: translate(0) rotate(0);
      opacity: 1;
    }

    100% {
      transform: translate(-1500%, -2000%) rotate(180deg);
      opacity: 0;
    }
  }

  @keyframes leaf2 {
    0% {
      transform: translate(0) rotate(0);
      opacity: 1;
    }
    100% {
      transform: translate(1000%, -2000%) rotate(180deg);
      opacity: 0;
    }
  }

  @keyframes leaf3 {
    0% {
      transform: translate(0) rotate(0);
      opacity: 1;
    }
    100% {
      transform: translate(-500%, -2000%) rotate(180deg);
      opacity: 0;
    }
  }

  @keyframes leaf4 {
    0% {
      transform: translate(0) rotate(0);
      opacity: 1;
    }
    100% {
      transform: translate(-2000%, -500%) rotate(180deg);
      opacity: 0;
    }
  }

  @keyframes leaf5 {
    0% {
      transform: translate(0) rotate(0);
      opacity: 1;
    }
    100% {
      transform: translate(3000%, -500%) rotate(180deg);
      opacity: 0;
    }
  }

  @keyframes leaf6 {
    0% {
      transform: translate(0) rotate(0);
      opacity: 1;
    }
    100% {
      transform: translate(2500%, -800%) rotate(180deg);
      opacity: 0;
    }
  }

  @keyframes leaf7 {
    0% {
      transform: translate(0) rotate(0);
      opacity: 1;
    }
    100% {
      transform: translate(2500%, -800%) rotate(180deg);
      opacity: 0;
    }
  }
}
</style>
